"use client";

import { ShareButton, type IShareButtonProps } from "./ShareButton";

/** Client wrapper for share actions on server-rendered blog cards. */
export function ShareButtonWrapper(
  props: IShareButtonProps
): React.ReactElement {
  return <ShareButton {...props} />;
}
